import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { fromDateStampObject } from './translator';
const MONTHS_IN_YEAR = 12;
const JANUARY = 1;
const DAYS_IN_MONTH_ORDER = 100;
const firstDayOf = (month)=>fromDateStampObject(_object_spread_props(_object_spread({}, month), {
        day: 1
    }));
export const calendarMonthOf = (param)=>{
    let { year, month } = param;
    return {
        year,
        month
    };
};
export const monthOrderOf = (param)=>{
    let { year, month } = param;
    return year * MONTHS_IN_YEAR + month;
};
export const dayOrderOf = (date)=>monthOrderOf(calendarMonthOf(date)) * DAYS_IN_MONTH_ORDER + date.day;
export const monthKeyOf = (param)=>{
    let { year, month } = param;
    return "".concat(year, "-").concat(month);
};
export const monthHeadingOf = (month)=>firstDayOf(month).toLocaleDateString('en-US', {
        month: 'short',
        year: 'numeric'
    });
export const monthProseNameOf = (month)=>firstDayOf(month).toLocaleDateString('en-US', {
        month: 'long',
        year: 'numeric'
    });
const shortMonthOf = (month)=>firstDayOf(month).toLocaleDateString('en-US', {
        month: 'short'
    });
export const monthTickLabelOf = (month)=>month.month === JANUARY ? "".concat(shortMonthOf(month), " '").concat(String(month.year).slice(2)) : shortMonthOf(month);
export const monthsFrom = (start, count)=>Array.from({
        length: count
    }, (_, offset)=>{
        const monthsFromJanuary = start.month - 1 + offset;
        return {
            year: start.year + Math.floor(monthsFromJanuary / MONTHS_IN_YEAR),
            month: monthsFromJanuary % MONTHS_IN_YEAR + 1
        };
    });
export const monthsBetween = (earlier, later)=>monthOrderOf(later) - monthOrderOf(earlier);
